module.exports = __webpack_public_path__ + "media/img/home/img_wedding-9330e884683d89ed65df840db7aabc64.png";